<template>
  <input :type="inputType" @input="onInput" :value="editValue" :placeholder="placeholder" class="input date-input" />
</template>

<script>
export default {
  name: 'DataInput',
  props: ['value'],
  data () {
    return {
      nativeDate: true,
      editValue: ''
    }
  },
  computed: {
    inputType () { return this.nativeDate ? 'date' : 'text' },
    placeholder () { return this.nativeDate ? '' : 'dd/mm/yyyy' }
  },
  created () {
    var invalidDate = 'not-a-date'
    var input = document.createElement('input')
    input.setAttribute('type', 'date')
    input.setAttribute('value', invalidDate)
    this.nativeDate = false // input.value !== invalidDate
    if (!this.nativeDate) {
      let moment = this.$moment(this.value, 'YYYY-MM-DD', true)
      this.editValue = moment.isValid() ? moment.format('DD/MM/YYYY') : ''
    } else {
      this.editValue = this.value
    }
  },
  methods: {
    onInput (e) {
      let value = e.target.value.trim()
      if (this.nativeDate) {
        this.$emit('input', value)
      } else {
        let moment = this.$moment(value, 'DD/MM/YYYY', true)
        this.$emit('input', moment.isValid() ? moment.format('YYYY-MM-DD') : '0000-00-00')
      }
    }
  }
}
</script>

<style>

</style>
